var mapsCenters = [];
var map;
var latLonBounds;
var googleMarkers = [];
var infowindow = null;
var mapDefaults = {
	latitude: 59.963934,
	longitude: 10.781839,
	zoom: 17,
};
var manualPositioning = false;

// Complianz blocks the Google Maps API script until cookie consent is given, so
// createGoogleMap() may be called (e.g. from inline template scripts) before the
// API has loaded. Queue those calls and poll for the API to become available, so
// the map appears right after accepting cookies instead of needing a refresh.
// We deliberately don't hook into the Maps script's load event or a ?callback=
// param on its src — Complianz matches/unblocks that script tag by its exact
// markup, and altering it risks breaking that match (as happened previously).
window.oxerGmapsQueue = window.oxerGmapsQueue || [];
var oxerGmapsPollInterval = null;

function oxerGmapsStartPolling() {
	if ( oxerGmapsPollInterval ) {
		return;
	}

	oxerGmapsPollInterval = setInterval( function() {
		if ( typeof google === 'undefined' || !google.maps ) {
			return;
		}

		clearInterval( oxerGmapsPollInterval );
		oxerGmapsPollInterval = null;

		var queued = window.oxerGmapsQueue.splice( 0 );
		queued.forEach( function( args ) {
			createGoogleMap( args[ 0 ], args[ 1 ] );
		} );
	}, 250 );
}

function createGoogleMap( mapSettings, markers ) {
	if ( typeof google === 'undefined' || !google.maps ) {
		window.oxerGmapsQueue.push( [ mapSettings, markers ] );
		oxerGmapsStartPolling();
		return;
	}

	if ( !mapSettings.element.length ) {
		return;
	}

	var latitude = mapDefaults.latitude;
	if ( mapSettings.latitude ) {
		latitude = mapSettings.latitude;
	}

	var longitude = mapDefaults.longitude;
	if ( mapSettings.latitude ) {
		longitude = mapSettings.longitude;
	}

	var zoom = mapDefaults.zoom;
	if ( mapSettings.zoom ) {
		zoom = mapSettings.zoom;
	}

	var scrollwheel = false;
	if ( mapSettings.scrollwheel ) {
		scrollwheel = mapSettings.scrollwheel;
	}

	var styles = [{
		"featureType": "water",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#d3d3d3",
		}],
	}, {
		"featureType": "transit",
		"stylers": [{
			"color": "#808080",
		}, {
			"visibility": "off",
		}],
	}, {
		"featureType": "road.highway",
		"elementType": "geometry.stroke",
		"stylers": [{
			"visibility": "on",
		}, {
			"color": "#b3b3b3",
		}],
	}, {
		"featureType": "road.highway",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#ffffff",
		}],
	}, {
		"featureType": "road.local",
		"elementType": "geometry.fill",
		"stylers": [{
			"visibility": "on",
		}, {
			"color": "#ffffff",
		}, {
			"weight": 1.8,
		}],
	}, {
		"featureType": "road.local",
		"elementType": "geometry.stroke",
		"stylers": [{
			"color": "#d7d7d7",
		}],
	}, {
		"featureType": "poi",
		"elementType": "geometry.fill",
		"stylers": [{
			"visibility": "on",
		}, {
			"color": "#ebebeb",
		}],
	}, {
		"featureType": "administrative",
		"elementType": "geometry",
		"stylers": [{
			"color": "#a7a7a7",
		}],
	}, {
		"featureType": "road.arterial",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#ffffff",
		}],
	}, {
		"featureType": "road.arterial",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#ffffff",
		}],
	}, {
		"featureType": "landscape",
		"elementType": "geometry.fill",
		"stylers": [{
			"visibility": "on",
		}, {
			"color": "#efefef",
		}],
	}, {
		"featureType": "road",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#696969",
		}],
	}, {
		"featureType": "administrative",
		"elementType": "labels.text.fill",
		"stylers": [{
			"visibility": "on",
		}, {
			"color": "#737373",
		}],
	}, {
		"featureType": "poi",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off",
		}],
	}, {
		"featureType": "poi",
		"elementType": "labels",
		"stylers": [{
			"visibility": "off",
		}],
	}, {
		"featureType": "road.arterial",
		"elementType": "geometry.stroke",
		"stylers": [{
			"color": "#d6d6d6",
		}],
	}, {
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off",
		}],
	}, {}, {
		"featureType": "poi",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#dadada",
		}],
	}];

	var mapLocation = new google.maps.LatLng( latitude, longitude );

	var mapOptions = {
		zoom: zoom,
		center: mapLocation,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		draggable: true,
		scrollwheel: scrollwheel,
		gestureHandling: 'cooperative',
		mapTypeControl: false,
		mapTypeControlOptions: {
			style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
			position: google.maps.ControlPosition.TOP_CENTER,
		},
		zoomControl: true,
		zoomControlOptions: {
			position: google.maps.ControlPosition.RIGHT_TOP,
		},
		scaleControl: false,
		streetViewControl: false,
		streetViewControlOptions: {
			position: google.maps.ControlPosition.RIGHT_TOP,
		},
		fullscreenControl: false,
	};

	map = new google.maps.Map( mapSettings.element[ 0 ], mapOptions );

	if ( mapSettings.maxZoom ) {
		map.setOptions( { maxZoom: mapSettings.maxZoom } );
	}

	if ( mapSettings.satellite ) {
		map.setMapTypeId( 'satellite' );
	} else {
		var styledMap = new google.maps.StyledMapType( styles, { name: "Styled Map" } );
		map.mapTypes.set( 'map_style', styledMap );
		map.setMapTypeId( 'map_style' );
	}

	latLonBounds = new google.maps.LatLngBounds();

	infowindow = new google.maps.InfoWindow( {
		content: '...',
		maxWidth: 500,
	} );

	/*
	map.addListener( 'center_changed', function() {
		resetMapOverlays();
	} );

	map.addListener( 'bounds_changed', function() {
		resetMapOverlays();
	} );

	map.addListener( 'zoom_changed', function() {
		resetMapOverlays();
	} );
	 */

	if ( markers ) {
		for ( var markerIndex = 0; markerIndex < markers.length; markerIndex++ ) {
			var markerPosition = new google.maps.LatLng( markers[ markerIndex ].latitude, markers[ markerIndex ].longitude );

			latLonBounds.extend( markerPosition );

			var markerTitle = mapDefaults.title;
			if ( markers[ markerIndex ].title ) {
				markerTitle = markers[ markerIndex ].title;
			}

			var markerImage = new google.maps.MarkerImage( mapDefaults.marker, new google.maps.Size( 29, 42 ), new google.maps.Point( 0, 0 ), new google.maps.Point( 15, 42 ) );
			if ( markers[ markerIndex ].markerImage ) {
				var markerScale = markers[ markerIndex ].markerScale || 1;
				var markerWidth = parseInt( markers[ markerIndex ].markerSize.width );
				var markerHeight = parseInt( markers[ markerIndex ].markerSize.height );
				var markerScaledWidth = markerWidth * markerScale;
				var markerScaledHeight = markerHeight * markerScale;

				markerImage = {
					url: markers[ markerIndex ].markerImage,
					scaledSize: new google.maps.Size( markerScaledWidth, markerScaledHeight ),
				};
				if ( markers[ markerIndex ].markerAnchor ) {
					markerImage.anchor = new google.maps.Point( parseInt( markers[ markerIndex ].markerAnchor.x ) * markerScale, parseInt( markers[ markerIndex ].markerAnchor.y ) * markerScale );
				}
			}

			var infowWindowContent;
			if ( mapSettings.infoWindows ) {
				var infowWindowContent = '<div class="info-window">';

				if ( markers[ markerIndex ].permalink ) {
					infowWindowContent += '<a href="' + markers[ markerIndex ].permalink + '" class="grid grid-cols-2 invisible-link relative">';
				}

				if ( markers[ markerIndex ].image ) {
					infowWindowContent += '<div class="bg-cover bg-center bg-no-repeat" style="background-image: url(\'' + markers[ markerIndex ].image + '\');"></div><div class="p-5 pb-10">';
				} else {
					infowWindowContent += '<div class="p-5 pb-10 col-span-2">';
				}

				if ( markers[ markerIndex ].tags ) {
					infowWindowContent += '<div class="flex flex-wrap gap-2 pb-5">' + markers[ markerIndex ].tags + '</div>';
				}

				if ( markers[ markerIndex ].title ) {
					infowWindowContent += '<div class="h3 pb-2">' + markers[ markerIndex ].title + '</div>';
				}

				if ( markers[ markerIndex ].subtitle ) {
					infowWindowContent += '<div class="paragraph-3 line-clamp-3">' + markers[ markerIndex ].subtitle + '</div>';
				}

				infowWindowContent += '<div class="pt-10"><div class="a inline-block"><span class="block relative">Gå til eiendom</span></div></div>';

				infowWindowContent += '</div>';

				if ( markers[ markerIndex ].permalink ) {
					infowWindowContent += '</a>';
				}

				infowWindowContent += '</div>';
			}

			var label = null;
			if ( mapSettings.clusterer ) {
				label = {
					text: (mapSettings.clusterer) ? '1' : '',
					fontSize: '16px',
					color: "white",
				};
			}

			var marker = new google.maps.Marker( {
				title: markerTitle,
				position: markerPosition,
				zIndex: 1,
				html: infowWindowContent,
				map: map,
				id: markers[ markerIndex ].id,
				icon: markerImage,
				label: label,
			} );

			if ( infowWindowContent ) {
				google.maps.event.addListener( marker, 'click', function() {
					infowindow.setContent( this.html );
					infowindow.open( map, this );
				} );
			}

			if ( mapSettings.infoOverlay ) {
				google.maps.event.addListener( marker, 'click', function() {
					resetMapOverlays();
					jQuery( '#overlay-' + this.id ).removeClass( 'hidden' );
					map.setCenter( this.position );
					manualPositioning = true;

					googleMarkers.forEach( function( m ) {
						var label = m.getLabel();

						label.color = "white";
						m.setLabel( label );

						if ( mapSettings.defaultMarkerImage ) {
							var defaultMarkerImage = {
								url: mapSettings.defaultMarkerImage,
								scaledSize: new google.maps.Size( markerScaledWidth, markerScaledHeight ),
							};
							m.setIcon( defaultMarkerImage );
						}
					} );

					var label = this.label;
					this.label.color = "#00261d";
					this.setLabel( label );

					if ( mapSettings.activeMarkerImage ) {
						var activeMarkerImage = {
							url: mapSettings.activeMarkerImage,
							scaledSize: new google.maps.Size( markerScaledWidth, markerScaledHeight ),
						};
						this.setIcon( activeMarkerImage );
					}
				} );
			}

			googleMarkers.push( marker );
		}
	}

	if ( mapSettings.clusterer ) {
		new markerClusterer.MarkerClusterer( {
			map: map,
			markers: googleMarkers,
			renderer: {
				render: function( o ) {
					var markers = o.markers;
					var position = o._position;
					return new google.maps.Marker( {
						title: markerTitle,
						position: {
							lat: position.lat(),
							lng: position.lng(),
						},
						zIndex: 1,
						map: map,
						icon: markerImage,
						label: {
							text: (markers.length > 10) ? '10+' : '' + markers.length,
							fontSize: '16px',
							color: "white", // fontFamily, fontWeight
						},
					} );
				},
			},
		} );
	}

	if ( markers.length > 1 ) {
		map.fitBounds( latLonBounds );
	} else if ( markers.length ) {
		map.setCenter( new google.maps.LatLng( markers[ 0 ].latitude, markers[ 0 ].longitude ) );
	}

	// Center the map when resizing the window
	google.maps.event.addDomListener( window, 'resize', function() {
		map.setCenter( mapLocation );
		if ( markers.length > 1 ) {
			map.fitBounds( latLonBounds );
		} else if ( markers.length ) {
			map.setCenter( new google.maps.LatLng( markers[ 0 ].latitude, markers[ 0 ].longitude ) );
		}
	} );

	jQuery( '.map' ).on( 'click', function() {
		if ( !manualPositioning ) {
			resetMapOverlays();
		}

		manualPositioning = false;
	} );
}

function resetMapOverlays() {
	jQuery( '.map-overlay' ).addClass( 'hidden' );
}

function showStreetview( element, streetviewSettings ) {
	var povPitch = 50;
	if ( streetviewSettings.pitch ) {
		povPitch = streetviewSettings.pitch;
	}

	var povHeading = 120;
	if ( streetviewSettings.heading ) {
		povHeading = streetviewSettings.heading;
	}

	var panoramaOptions = {
		position: new google.maps.LatLng( streetviewSettings.latitude, streetviewSettings.longitude ),
		draggable: false,
		scrollwheel: false,
		pov: {
			heading: povHeading,
			pitch: povPitch,
		},
	};
	var panorama = new google.maps.StreetViewPanorama( element[ 0 ], panoramaOptions );
}

export function updateGoogleMapMarkers( ids ) {
	for ( var markerIndex = 0; markerIndex < googleMarkers.length; markerIndex++ ) {
		if ( ids === 'all' || ids.indexOf( googleMarkers[ markerIndex ].id ) > -1 ) {
			googleMarkers[ markerIndex ].setVisible( true );
		} else {
			googleMarkers[ markerIndex ].setVisible( false );
		}
	}

	fitGoogleMapMarkers();
}

export function fitGoogleMapMarkers() {
	latLonBounds = new google.maps.LatLngBounds();
	var visibleMarkerCounter = 0;

	for ( var markerIndex = 0; markerIndex < googleMarkers.length; markerIndex++ ) {
		if ( googleMarkers[ markerIndex ].visible ) {
			visibleMarkerCounter++;
			latLonBounds.extend( googleMarkers[ markerIndex ].position );
		}
	}

	if ( visibleMarkerCounter >= 1 ) {
		map.fitBounds( latLonBounds );
	}
}

window.createGoogleMap = createGoogleMap;
